var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"justify-center"},[_c('v-card',[_c('v-card-text',[_c('QrCode',{attrs:{"value":_vm.value,"size":250,"level":"H"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }